/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProviderAccreditationDocumentsAliases {
  CHECKBOX_UNDETERMINED_VALIDITY = 'checkbox-undetermined-validity',
  DATE_FIELD_0 = 'date-field-0',
  DATE_FIELD_VALIDITY = 'date-field-validity',
  DECK_0 = 'deck-0',
  FETCH_DOCUMENT = 'fetch-document',
  FETCH_DOCUMENTS = 'fetch-documents',
  FETCH_PENDENCIES = 'fetch-pendencies',
  FIELD_0 = 'field-0',
  FIELD_2 = 'field-2',
  FIELD_EMISSION_DATE = 'field-emission-date',
  FIELD_EMISSION_DATE_DISABLED = 'field-emission-date-disabled',
  FIELD_FILE_UPLOADER = 'field-file-uploader',
  FIELD_ISSUE_DATE = 'field-issue-date',
  FIELD_ORIENTATION = 'field-orientation',
  FIELD_UNDETERMINED_VALIDITY = 'field-undetermined-validity',
  FIELD_VALIDITY_DATE = 'field-validity-date',
  FIELD_VALIDITY_DATE_DISABLED = 'field-validity-date-disabled',
  FILE_UPLOADER = 'file-uploader',
  FORM_0 = 'form-0',
  FORM_DOCUMENT = 'form-document',
  HPMS_CUSTOM_CARD_DOCUMENT = 'hpms-custom-card-document',
  HPMS_DYNAMIC_CONTENT_FIELD_ATTACHMENT = 'hpms-dynamic-content-field-attachment',
  HPMS_DYNAMIC_CONTENT_FIELD_EXPIRATION_DATE = 'hpms-dynamic-content-field-expiration-date',
  INPUT_0 = 'input-0',
  INPUT_VALIDITY_DATE = 'input-validity-date',
  LAYOUT_DOCUMENTS = 'layout-documents',
  LAYOUT_HEADER = 'layout-header',
  LAYOUT_TITLE = 'layout-title',
  LINK_FILE_TEMPLATES = 'link-file-templates',
  LINK_FILE_TEMPLATES_MOBILE = 'link-file-templates-mobile',
  MAPPER_0 = 'mapper-0',
  MODAL_DOCUMENT = 'modal-document',
  PANEL_DOCUMENT = 'panel-document',
  PANEL_DOCUMENT_MAIN = 'panel-document-main',
  PANEL_DOCUMENTS = 'panel-documents',
  PANEL_FILE_TEMPLATES = 'panel-file-templates',
  PANEL_FILE_TEMPLATES_MOBILE = 'panel-file-templates-mobile',
  PANEL_PENDENCIES = 'panel-pendencies',
  PANEL_TITLE = 'panel-title',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_3 = 'text-3',
  TEXT_5 = 'text-5',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { ProviderAccreditationDocumentsAliases };
